import Backbone from 'backbone';
import Cocktail from 'backbone.cocktail';

// https://github.com/onsi/cocktail#if-you-dont-mind-monkeypatching
Cocktail.patch(Backbone);

/**
 * extend backbone views with queryselectors
 * usage in a BB View:
 * this.query(this.someElement, '.selector')
 * this.query('.selector')
 */
export default Backbone.View.extend({
	query: function(root, selector) {
		if (typeof selector === 'undefined') {
			selector = root;
			root = this.el || document.body;
		}

		return root.querySelector(selector);
	},

	queryAll: function(root, selector) {
		if (typeof selector === 'undefined') {
			selector = root;
			root = this.el || document.body;
		}

		return [].slice.call(root.querySelectorAll(selector));
	}
});
